import { render, staticRenderFns } from "./ProjectTableFrom.vue?vue&type=template&id=50314722&"
import script from "./ProjectTableFrom.vue?vue&type=script&lang=js&"
export * from "./ProjectTableFrom.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTableFrom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports